import "./Code.scss";

import { useState } from "react";
import { Button } from "react-bootstrap";

import { CodeIcon } from "../../../../components/icons";
import type { CodeProps } from "./";
import { CodeModal } from "./CodeModal";

const Code: React.FC<CodeProps> = ({
  messages,
  isStream,
  model,
  seed,
  tools,
  cacheControl,
}) => {
  const [show, setShow] = useState(false);

  const toggleModal = () => {
    setShow(!show);
  };

  return (
    <>
      <Button
        onClick={toggleModal}
        className="fw-bold flex-shrink-0 d-flex align-items-center gap column-gap-2"
      >
        <CodeIcon />
        View code
      </Button>
      {show && (
        <CodeModal
          hideModal={toggleModal}
          messages={messages}
          isStream={isStream}
          model={model}
          seed={seed}
          tools={tools}
          cacheControl={cacheControl}
        />
      )}
    </>
  );
};

export { Code };
